(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-old"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hello-page"] && !Shopify.designMode) return;
  try {
    
            jQuery(document).ready(function($){
                var timer = {};
                $(".accordion-note.on").each(function(){
                    var id = $(this).attr("id");
                    timer[id] = null;
                });
              
                $(window,document,"html,body").resize(function(){
                    $(".accordion-note.on").each(function(){
                        $(this).removeClass("on");
                    });
                });
                $(".accordion-note").on("click", function(){
                    var id = $(this).attr("id");
                    clearTimeout(timer[id]);
                    if($(window).innerWidth() < 750){
                        if(!$(this).hasClass("on")){
                            var h = $(this).children().innerHeight();
                            $(this).css("height", h);
                        }else{
                            /*
                            timer[id] = setTimeout(function(){
                                var scrollTarget = $('#' + id).offset().top;
                                $('body,html').animate({scrollTop: scrollTarget});
                            }, 700);
                            */
                        }
                        $(this).toggleClass("on");
                    }
                });
            });
      
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page-diagnosis-result"]) return;
  try {
    
	jQuery(document).ready(function ($) {
		var faq = new Array();
		if($(".diagnosis-faq").length){
			$(".diagnosis-faq").each(function(){
				faq.push(0);
			});
		}

		var data = {}, results = {};
		if($(".diagnosis-result__data-in").length){
			$(".diagnosis-result__data-in").each(function(){
				var thisId = 'r' + $(this).data("result");
				var conditions = new Array();
				if($(this).data("conditions")) {
					conditions = $(this).data("conditions").split(";");
					$.each(conditions, function(){
						var conditions_id = 'c_' + this;
						results[conditions_id] = thisId;
					});
				}
				var image = "";
				if($(this).children("img").attr("src")){
					image = $(this).children("img").attr("src");
				}
				data[thisId] = {
					'result': $(this).data("result"),
					'label': $(this).data("title"),
					'description': $(this).data("description"),
					'link': $(this).data("link"),
					'conditions': conditions,
					'image': image
				};
				data[thisId]['other'] = new Array();
				if($(this).children(".diagnosis-result__data-in-other").length){
					$(this).children(".diagnosis-result__data-in-other").each(function(){
						var image = "";
						if($(this).children("img").attr("src")){
							image = $(this).children("img").attr("src");
						}
						tmpArray = {
							'label': $(this).data("title"),
							'copy': $(this).data("copy"),
							'description': $(this).data("description"),
							'link': $(this).data("link"),
							'image': image
						};
						data[thisId]['other'].push(tmpArray);
					});
				}
			});
		}

		$(window,document,"html,body").resize(function(){
			$(".diagnosis-faq").each(function(){
				if(!$(this).hasClass("init")){
						var faqH = $(this).children().innerHeight();
						$(this).css("height", faqH).removeClass("init");
				}
			});
		});

		$(".diagnosis-a").on("click", function(){
			if(!$(".diagnosis-faq__wrap").hasClass("end")){
				var q = $(this).data("q");
				var a = $(this).data("a");
				var next = q + 1;
				var sw = $(this).hasClass("on");
				faq[q] = (sw ? 0 : a);
				$(".diagnosis-a.on[data-q='" + q + "']").removeClass("on");
				if(!sw){
					$(this).addClass("on");
				}
				if($("#faq-" + next).length){
					if($("#faq-" + next).hasClass("init")){
						var faqH = $("#faq-" + next).children().innerHeight();
						$("#faq-" + next).css("height", faqH).removeClass("init");
						var target_top = $("#faq-" + next).offset().top;
						$('body,html').animate({scrollTop: target_top}, "slow");
					}
				}
				var len = 0;
				$.each(faq, function(){
					if(this > 0){
						len++;
					}
				});
				if(len >= faq.length){
					$(".diagnosis-faq__wrap").addClass("end");
					var conditionId = 'c_' + faq.join("-");
					var myDataId = results[conditionId];
					var myData = data[myDataId];
					$("#diagnosis-result__label").empty().text(myData.label);
					$("#diagnosis-result__note").empty().html(myData.description);
					$("#diagnosis-result__image").attr("src", myData.image);
					$("#diagnosis-result__more").attr("href", myData.link);

					$("#diagnosis-result__others-row").empty();
					if(myData.other.length) {
						$("#diagnosis-result__others").show();
						$.each(myData.other, function(){
							var copy = $(".diagnosis-result__others-row.master").clone(true);
							copy.removeClass("master");
							copy.find(".diagnosis-result__label").empty().text(this.label);
							copy.find(".diagnosis-result__copy").empty().text(this.copy);
							copy.find(".diagnosis-result__note").empty().html(this.description);
							copy.find(".diagnosis-result__image").attr("src", this.image);
							copy.find(".diagnosis-result__more").attr("href", this.link);
							copy.appendTo("#diagnosis-result__others-row");
						});
					}else{
						$("#diagnosis-result__others").hide();
					}

					var resultH = $("#diagnosis-result > .block-box").innerHeight();
					$("#diagnosis-result").css("height", resultH).addClass("on");
					var target_top = $("#diagnosis-result").offset().top;
					$('body,html').animate({scrollTop: target_top}, "slow");
				}
			}
		});
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product_backup"]) return;
  try {
    
  
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sections-recommendItem"] && !Shopify.designMode) return;
  try {
    
  // Slickスライダーを初期化（元のシンプルなコード）
  jQuery(document).ready(function ($) {
    // セレクタをIDとセクションIDで正確に指定
    var $slider = $('#slideProductBlock[data-section-id="{{ section.id }}"] .slider_new');
    
    // もし元のHTMLに data-section-id がなければ、IDだけで探す
    if ($slider.length === 0) {
      $slider = $('#slideProductBlock .slider_new');
    }

    $slider.slick({
        autoplay: true,
        adaptiveHeight: false,
        dots: false,
        slidesToShow: 5,
        responsive: [
            {
                breakpoint: 1720,
                settings: {
                slidesToShow: 4,
                },
            },
            {
                breakpoint: 992,
                settings: {
                slidesToShow: 3,
                },
            },
            {
                breakpoint: 768,
                settings: {
                slidesToShow: 1,
                },
            },
        ],
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sections-viewItem"] && !Shopify.designMode) return;
  try {
    
jQuery(document).ready(function ($) {
  var viewed = JSON.parse(localStorage.getItem('viewedProducts')) || [];
  var $slider = $('#recentlyViewedSlider');

  if (viewed.length === 0) {
    $slider.append('<p>最近見た商品はありません。</p>');
    return;
  }

 // slick 初期化を呼ぶ前に HTML を全部追加
viewed.forEach(function(p) {
  var html = `
    <a href="${p.url}" class="slider-img">
      <div class="imgBox relative">
        <img 
          src="${p.image}" 
          alt="${p.title}" 
          loading="lazy" 
          width="600" 
          height="600" 
          class="main-image"
        />
        ${p.second_image ? `
          <img 
            src="${p.second_image}" 
            alt="${p.title}" 
            loading="lazy" 
            width="600" 
            height="600" 
            class="sub-image hov"
          />
        ` : ''}
      </div>
      <div class="infoBox">
        <h3 class="shippori">${p.title}</h3>
        <div class="hashtagBox">
          ${
            (p.tags && p.tags.length > 0)
            ? p.tags.slice(0,3).map(tag => `<h4 class="hashtag">${tag}</h4>`).join('')
            : '<h4 class="hashtag">#商品</h4>'
          }
        </div>
        <div class="price">${p.price}</div>
        <div class="review-summary-container" data-pid="${p.id || ''}" data-action="summary" data-group="true"></div>
      </div>
    </a>`;
  $slider.append(html);
});


  // 少し遅らせて slick を初期化（DOM構築完了後）
  setTimeout(function() {
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }
    $slider.slick({
      autoplay: true,
      adaptiveHeight: false,
      dots: false,
      slidesToShow: 5,
      
      responsive: [
        { breakpoint: 1720, settings: { slidesToShow: 4 } },
        { breakpoint: 992, settings: { slidesToShow: 3 } },
        { breakpoint: 768, settings: { slidesToShow: 1 } },
      ],
    });
  }, 200); // ← 200ms 遅らせるのがポイント
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top_new_product"] && !Shopify.designMode) return;
  try {
    
  jQuery(document).ready(function ($) {
    var $slider = $('#slideProductBlock .slider_new');
    
    $slider.slick({
        autoplay: false,
        adaptiveHeight: true, 
        dots: false,
        slidesToShow: 5,
        responsive: [
            {
                breakpoint: 1720,
                settings: { slidesToShow: 4 },
            },
            {
                breakpoint: 992,
                settings: { slidesToShow: 3 },
            },
            {
                breakpoint: 768,
                settings: { slidesToShow: 1 },
            },
        ],
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top_news"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var newsSections = document.querySelectorAll('.js-tab-section');

  newsSections.forEach(function(section) {
    var tabs = section.querySelectorAll('.tag');
    var contents = section.querySelectorAll('.content');

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        tabs.forEach(function(t) { t.classList.remove('active'); });
        contents.forEach(function(c) { c.classList.remove('active'); });

        this.classList.add('active');

        var targetId = this.getAttribute('data-target-id');
        var targetContent = document.getElementById(targetId);
        
        if (targetContent) {
          targetContent.classList.add('active');
        }
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top_ranking"] && !Shopify.designMode) return;
  try {
    
(function() {
  // ■ 1. Slickスライダーの設定
  var slickOptions = {
    autoplay: false,
    adaptiveHeight: true,
    dots: false,
    slidesToShow: 5,
    initialSlide: 0,
    arrows: true,
    responsive: [
      { breakpoint: 1720, settings: { slidesToShow: 4 }},
      { breakpoint: 992, settings: { slidesToShow: 3 }},
      { breakpoint: 768, settings: { slidesToShow: 1 }}
    ]
  };

  // ■ 2. スライダー初期化関数
  function initSlick(element) {
    if (typeof jQuery === 'undefined' || !element) return;
    var $el = jQuery(element);
    
    // setTimeoutを使用して描画待ちをする
    setTimeout(function() {
      if (!$el.hasClass('slick-initialized')) {
        $el.slick(slickOptions);
      } else {
        $el.slick('setPosition');
        $el.slick('slickGoTo', 0, true);
      }
    }, 100);
  }

  // ■ 3. クリックイベント（IDに依存せず、親コンテナを探すロジック）
  document.addEventListener('click', function(e) {
    // e.target.closestはVanilla JSで要素を探す標準メソッド
    var clickedTab = e.target.closest('.js-ranking-tab');
    if (!clickedTab) return;

    var container = clickedTab.closest('#slideProductBlock');
    if (!container) return;

    // 既にアクティブなら無視
    if (clickedTab.classList.contains('active')) return;

    // (A) タブの切り替え
    var allTabs = container.querySelectorAll('.js-ranking-tab');
    allTabs.forEach(function(t) { t.classList.remove('active'); });
    clickedTab.classList.add('active');

    // (B) コンテンツの切り替え
    var index = clickedTab.getAttribute('data-index');
    
    var allContents = container.querySelectorAll('.content');
    var targetContent = container.querySelector('.content[data-index="' + index + '"]');

    // 全て非表示に（CSSのdisplay制御をリセット）
    allContents.forEach(function(c) { 
      c.classList.remove('active'); 
      c.style.display = ''; 
    });

    if (targetContent) {
      targetContent.classList.add('active');
      initSlick(targetContent); // スライダー再描画
    } else {
      console.error('ターゲットコンテンツが見つかりません: index=' + index);
    }
  });

  // ■ 4. 初期ロード時の処理
  document.addEventListener('DOMContentLoaded', function() {
    var allBlocks = document.querySelectorAll('#slideProductBlock');
    allBlocks.forEach(function(block) {
      var activeContent = block.querySelector('.content.active');
      if (activeContent) {
        initSlick(activeContent);
      }
    });
  });
  
  // テーマエディタ用（セクション再読み込み時のイベント）
  document.addEventListener('shopify:section:load', function(e) {
    if(e.target.querySelector('#slideProductBlock')) {
       var activeContent = e.target.querySelector('.content.active');
       initSlick(activeContent);
    }
  });

})();

  } catch(e) { console.error(e); }
})();
})();
